<template>
  <div class="popover-wrapper">
    <el-popover
      ref="popover"
      :popper-class="className"
      :offset="offset"
      visible-arrow
    >
      <div
        slot="reference"
        :tabindex="1"
        :class="[
          'cascader-popover',
          isValueEmpty ? 'cascader-popover-required' : '',
        ]"
        :style="{width: width}"
        @focus="handleFocus"
        @click.stop="handleShowPopover"
      >
        <span v-show="!value" class="placeholder">{{ $t('请选择') }}</span>
        <span v-show="value" class="placeholder value-text">{{ value }}</span>
        <i
          :class="[
            'el-icon-arrow-up el-icon-arrow',
            isAcitve ? 'el-icon-arrow-change' : '',
          ]"
        ></i>
      </div>
      <div class="popper__arrow"></div>
      <slot></slot>
    </el-popover>
    <div v-show="requiredMsg && isValueEmpty" class="show-required">{{ requiredMsg }}</div>
  </div>
</template>

<script>
export default {
  name: 'CascaderPopover',
  components: {},
  props: {
    // 宽度
    width: {
      type: String,
      default: '150px'
    },
    // 输入框的值
    value: {
      type: String,
      default: ''
    },
    // 是否需要校验
    isRequired: {
      type: Boolean,
      default: false
    },
    // 触发隐藏popover
    isHidePopover: {
      type: Boolean,
      default: true
    },
    // 偏移量
    offset: {
      type: Number,
      default: 0
    },
    // 类名
    className: {
      type: String,
      default: 'popover'
    },
    // props
    requiredMsg: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // 控制箭头的状态
      isAcitve: false,
      isValueEmpty: false
    };
  },
  watch: {
    isRequired(val) {
      if (val) {
        setTimeout(() => {
          this.isValueEmpty = !this.value;
        }, 100);
      } else {
        setTimeout(() => {
          this.isValueEmpty = false;
        }, 100);
      }
    },
    isHidePopover() {
      this.handleHide();
    }
  },
  mounted() {
    document.addEventListener('click', this.handleHide);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleHide);
  },
  methods: {
    handleShowPopover() {
      this.isAcitve = !this.isAcitve;
    },
    handleHide() {
      this.isAcitve = false;
      this.$refs.popover.showPopper = false;
    },
    handleFocus() {
      if (!this.$refs.popover.showPopper) {
        this.$emit('click');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.popover-wrapper{
  .cascader-popover {
    border-radius: 3px;
    width: 228px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    height: 32px;
    line-height: 32px;
    outline: 0;
    padding: 0 15px;
    cursor: pointer;
    position: relative;
    background-color: #fff;

    .placeholder {
      color: #c0c4cc;

      &.value-text {
        color: #000;
      }
    }

    .el-icon-arrow {
      height: 32px;
      line-height: 32px;
      color: #c0c4cc;
      font-size: 14px;
      transform: rotateZ(180deg);
      cursor: pointer;
      position: absolute;
      top: 0;
      right: 10px;
      transition: all 0.3s;

      &.el-icon-arrow-change {
        transition: all 0.3s;
        transform: rotateZ(0);
      }
    }

    &.cascader-popover-required {
      border-color: #ff4949;

      &:hover {
        border-color: #ff4949;
      }

      &:focus {
        border-color: #ff4949;
      }
    }

    &:hover {
      border-color: #c0c4cc;
    }

    &:focus {
      border-color: $main;
    }
  }

  .show-required{
    position: absolute;
    top: 33px;
    height: 10px;
    font-size: 12px;
    color: #ff4949;
  }
}
</style>
